import _ from "lodash";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getOfficeListReq,
  getOfficeListResClear,
  setCurrentView,
} from "../../redux/assignCourse/actions";
import { setCurrentFilterView } from "../../redux/reports/actions";
import { SessionKeys } from "../../utils/AppUtils";
import Select from "react-select";

const ChooseOfficePeople = (props) => {
  const {
    selectedOfficeList,
    setSelectedOfficeList,
    isMobile,
    selectedBrokerageList,
    officeLabel,
  } = props;

  const dispatch = useDispatch();
  const officeListRes = useSelector((state) => state.assignCourse.officeList);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const [searchInput, setSearchInput] = useState("");
  const [officeList, setOfficeList] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [errorMsg, setErrorMsg] = useState("");
  const [officeOptList, setOfficeOptList] = useState([]);
  const [selectedOffice, setSelectedOffice] = useState([]);
  const [defaultValue, setDefaultValue] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(getOfficeListResClear());
    searchOffice();
    setIsLoading(true);
    return (() => {
      setOfficeList([]);
      setOfficeOptList([]);
    })
  }, [dispatch]);

  useEffect(() => {
    setIsLoading(true);
    searchOffice();
    setOfficeOptList([]);
    setOfficeList([]);
    setDefaultValue([]);
    setSelectedOfficeList([]);
  }, [selectedBrokerageList]);

  useEffect(() => {
    setSelectedCount(selectedOfficeList?.length);

    const newDefaultValue = selectedOfficeList.map((office) => ({
      value: office.office_id,
      label: `${office.office_name} (${office?.office_address})`,
      count: office.user_count,
    }));

    setDefaultValue(newDefaultValue);
  }, [selectedOfficeList]);

  useEffect(() => {
    if (searchInput !== undefined && searchInput.length > 2) searchOffice();
    else setErrorMsg("");
  }, [searchInput]);

  const searchOffice = () => {
    // console.log('officeListRes1')
    setOfficeList([]);
    setOfficeOptList([]);
    dispatch(
      getOfficeListReq({
        module: "getOfficeListSearch",
        postData: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          search: searchInput,
          brokerage: selectedBrokerageList,
          type: "report",
        },
      })
    );
  };

  const renderName = (office) => {
    return (
      <div>
        <div>{office.office_name}</div>
        <div>
          {office.office_address}, {office.city}, {office.province}
        </div>
      </div>
    );
  };

  useEffect(() => {
    // console.log('officeListRes: ', officeListRes)
    if (!_.isEmpty(officeListRes)) {
      setErrorMsg("");
      if (officeListRes?.status === "success") {
        const officeArr = officeListRes?.payload?.payload;
        setOfficeList(officeArr);
        setOfficeOptList(
          _.map(officeArr, (office) => {
            return {
              value: office.office_id,
              label: renderName(office),
              count: office.user_count,
            };
          })
        );
      } else {
        setOfficeList([]);
        setOfficeOptList([]);
        if (!_.isEmpty(searchInput) && searchInput?.length > 2) {
          setErrorMsg("No result found for your search.");
        } else {
          setErrorMsg("");
        }
      }
      setIsLoading(false);
    } else {
      // setOfficeList([]);
      // setOfficeOptList([]);
      setErrorMsg("");
    }
  }, [officeListRes]);

  const selectItem = (index) => {
    let tempArr = _.cloneDeep(officeList);
    let selectedTempArray = _.cloneDeep(selectedOfficeList);
    selectedTempArray.push(tempArr[index]);
    setSelectedOfficeList(selectedTempArray);
    tempArr.splice(index, 1);
    setOfficeList(tempArr);
  };

  const removeItem = (index) => {
    let selectedTempArray = _.cloneDeep(selectedOfficeList);
    let tempArr = _.cloneDeep(officeList);
    tempArr.push(selectedTempArray[index]);
    setOfficeList(tempArr);
    selectedTempArray.splice(index, 1);
    setSelectedOfficeList(selectedTempArray);
  };

  const applyOffice = () => {
    if (!_.isEmpty(selectedOffice)) {
      setErrorMsg("");
      let data = [];
      for (let office of officeList) {
        for (let sO of selectedOffice) {
          if (sO.value === office.office_id) {
            data.push(office);
          }
        }
      }
      setSelectedOfficeList(data);
    } else {
      // setErrorMsg("Please select at lease one office.");
    }
  };

  const getLabelText = (option) => {
    const labelElement = option.label.props.children;
    let labelText = "";

    if (Array.isArray(labelElement)) {
      labelElement.forEach((child) => {
        if (typeof child === "string") {
          labelText += child + " ";
        } else if (child.props && child.props.children) {
          labelText += child.props.children + " ";
        }
      });
    } else if (
      labelElement &&
      labelElement.props &&
      labelElement.props.children
    ) {
      labelText = labelElement.props.children;
    }

    return labelText.toLowerCase();
  };

  const handleSearch = (option, searchInput) => {
    const labelText = getLabelText(option);
    return labelText.includes(searchInput.toLowerCase());
  };

  return (
    <>
      <div className="chooseteams chooseppl">
        <div className="chooseteamate">
          <div className="headong d-flex justify-content-between">
            <h4>Choose People from {officeLabel}</h4>{" "}
          </div>
          <div className="input-lear position-relative d-flex">
            <label for="peoplesearch" className="input__label_learning">
              Search
            </label>
            {/* <input type="text" id="peoplesearch" name="peoplesearch" className="input_searchfield_search-cart " placeholder="Start searching"
							onChange={(evt) => {
								setSearchInput(evt.target.value)
							}} /> */}
            <Select
              isMulti
              name="colors"
              className="basic-multi-select w-100 multi-label-select"
              classNamePrefix="xsel"
              options={officeOptList}
              value={defaultValue}
              isLoading={isLoading}
              onChange={(e) => {
                console.log('office select', e, officeOptList, officeList);
                // setSelectedOffice(e)
                if (!_.isEmpty(e)) {
                  setErrorMsg("");
                  let data = [];
                  for (let office of officeList) {
                    for (let sO of e) {
                      if (_.toNumber(sO.value) === _.toNumber(office.office_id)) {
                        data.push(office);
                      }
                    }
                  }
                  console.log('office select', data);
                  setSelectedOfficeList(data);
                } else {
                  setSelectedOfficeList([]);
                  // setErrorMsg("Please select at lease one office.");
                }
              }}
              filterOption={handleSearch}
            />
          </div>
          <p className="error-msg">{errorMsg}</p>
          {/* <div className="search-team-result">
						{
							officeList?.map((item, index) => {
								return <div className="team-result-box">
									<div className="userteamname">{item?.office_name} <span className="peoplecount">{item?.user_count} people</span></div>
									<div className="addteammate" onClick={() => { selectItem(index) }}>+</div>
								</div>
							})
						}
					</div>
					<div className="teamselected">
						<div className="selectresilt">Selected Offices<strong>({selectedCount})</strong></div>
						<div className="search-team-result slectedteammates">
							{selectedOfficeList?.map((item, index) => {
								return <div className="team-result-box">
									<div className="userteamname">{item?.office_name} <span className="peoplecount">{item?.user_count} people</span></div>
									<div className="addteammate" onClick={() => {
										// console.log('removeItem');
										removeItem(index)
									}}>+</div>
								</div>
							})}

						</div>
					</div> */}
          {false && (
            <div className="buttonsteammate">
              {false && (
                <button
                  type="button"
                  className="btn btn-primary btn-block back-button"
                  onClick={() => {
                    dispatch(setCurrentFilterView(1));
                  }}
                >
                  Back
                </button>
              )}
              <button
                type="button"
                className="btn btn-primary btn-block setup-button"
                onClick={() => {
                  // setSelectedOfficeList(selectedOfficeList)
                  applyOffice();
                  // dispatch(setCurrentFilterView(1))
                }}
              >
                Apply
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ChooseOfficePeople;
